import { Col, Pagination, Row, Select, Space, Table, Input } from 'antd';
import React, { useState } from 'react';
import ActionButton from '../../../components/ActionButton';
import AddButton from '../../../components/AddButton';
import Confirm from '../../../components/Confirm';
import FormCreator from '../../../components/FormCreator';
import Typograpy from '../../../components/Typograpy';
import { useHideModal, useShowAlert, useShowModal } from '../../../hooks';
import { Container, AddContainer } from './style';
import { formData, initialValuesAdd } from './helper';
import { useEffect } from 'react';
import userService from '../../../services/users';
import organizationService from '../../../services/organization';
import provinceService from '../../../services/provinces';
import regionService from '../../../services/regions';
import objectService from '../../../services/objects';
import groupService from '../../../services/groups';
import FullScreen from '../../../components/Spinner/FullScreen';
import { FiSearch } from 'react-icons/fi';

export default () => {
  const { Option } = Select;
  const [users, setUsers] = useState([]);
  const [bool, setBool] = useState([]);
  const [loading, setLoading] = useState(false);
  const { success, error } = useShowAlert();
  const [search, setSearch] = useState(undefined);
  const [searchText, setSearchText] = useState(undefined);

  const [sections, setSections] = useState({
    role: [
      { _id: 'governor', title: 'Governor' },
      { _id: 'groupleader', title: 'Group leader' },
      { _id: 'supervisorleader', title: 'Supervisor leader' },
      { _id: 'admin', title: 'Admin' },
      { _id: 'supervisor', title: 'Supervisor' },
      { _id: 'groupadmin', title: 'Group admin' },
      { _id: 'regionsupervisor', title: 'Region supervisor' },
    ],
  });
  const [filterItems, setFilterItems] = useState({
    region: '',
    group: '',
    role: '',
    object: '',
  });
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);

  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();

  useEffect(() => {
    provinceService
      .getAll()
      .then((res) => {
        setSections((prevSections) => ({
          ...prevSections,
          province: res,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
    regionService
      .getAll()
      .then((res) => {
        setSections((prevSections) => ({
          ...prevSections,
          region: res,
          regions: res,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
    groupService
      .getAll()
      .then((res) => {
        setSections((prevSections) => ({
          ...prevSections,
          group: res,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
    organizationService
      .getAll({ limit: 1000, page: 1 })
      .then((res) => {
        setSections((prevSections) => ({
          ...prevSections,
          organization: res.docs,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    if (filterItems.region) {
      const payload = {
        parent: '62e7b2e89ea2ff5d7fa7d092',
        region: filterItems.region,
      };
      objectService
        .getAllSubsList(payload)
        .then((resp) => setSections({ ...sections, objects: resp }))
        .catch((err) => console.log(err));
    }
  }, [filterItems.region]);

  const fetchUserData = () => {
    setLoading(true);
    let data = { limit: size, page: page };
    filterItems?.region !== ''
      ? (data = { ...data, region: filterItems.region })
      : null;
    filterItems?.group !== ''
      ? (data = { ...data, group: filterItems.group })
      : null;
    filterItems?.role !== ''
      ? (data = { ...data, role: filterItems.role })
      : null;
    filterItems?.object !== ''
      ? (data = { ...data, object: filterItems.object })
      : null;
    search !== '' ? (data = { ...data, phone: search }) : null;
    searchText !== '' ? (data = { ...data, search: searchText }) : null;
    userService
      .getUsersByFilter(data)
      .then((res) => {
        setTotal(res?.totalDocs);
        let users = res?.docs?.map((item, index) => {
          return {
            ...item,
            phone:
              item?.role === 'groupadmin' || item?.role === 'groupleader'
                ? '+998' + item?.phone
                : '-',
            key: index + 1,
          };
        });
        setUsers(users);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchUserData();
  }, [bool, filterItems, page, size]);

  const changeData = (data) => {
    if (
      data?.role == 'governor' ||
      data?.role == 'supervisorleader' ||
      data?.role == 'admin'
    ) {
      return {
        firstName: data.firstName,
        lastName: data.lastName,
        middleName: data.middleName,
        username: data.username,
        password: data.password,
        province: data.province,
        active: data.active,
        phone: data.phone,
        role: data.role,
      };
    }

    if (data?.role === 'groupadmin') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        organization: data?.organization || '',
        object: data?.object || '',
        macCount: data?.macCount,
        region: data?.region,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
      };
    }
    if (data?.role === 'groupleader') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        organization: data?.organization,
        macCount: data?.macCount,
        regions: data.regions,
        password: data?.password,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
      };
    }
    if (data?.role == 'supervisor') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        password: data.password,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
      };
    }
    if (data?.role == 'regionsupervisor') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        password: data.password,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
        region: data?.region,
        // organization: data?.organization,
      };
    }
  };

  const changeUpdateData = (data) => {
    if (
      data?.role == 'governor' ||
      data?.role == 'supervisorleader' ||
      data?.role == 'admin'
    ) {
      return {
        firstName: data.firstName,
        lastName: data.lastName,
        middleName: data.middleName,
        username: data.username,
        password: data.password,
        province: data.province,
        active: data.active,
        phone: data.phone,
        role: data.role,
      };
    }

    if (data?.role === 'groupadmin') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        organization: data?.organization?._id || '',
        object: data?.object?._id || '',
        macCount: data?.macCount,
        region: data?.region,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
      };
    }
    if (data?.role === 'groupleader') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        organization: data?.organization?._id || '',
        macCount: data?.macCount,
        regions: data.regions,
        password: data?.password,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
      };
    }
    if (data?.role == 'supervisor') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        password: data.password,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
      };
    }
    if (data?.role == 'regionsupervisor') {
      return {
        firstName: data?.firstName,
        lastName: data?.lastName,
        middleName: data?.middleName,
        province: data?.province,
        password: data.password,
        group: data?.group,
        active: data?.active,
        phone: data?.phone,
        role: data?.role,
        region: data?.region,
        organization: data?.organization,
      };
    }
  };

  // Create

  const sendData = (data) => {
    hideModal();
    setLoading(true);
    let changeFormData = changeData(data);
    userService
      .create(changeFormData)
      .then(() => {
        setBool(!bool);
        success('Фойдаланувчи маълумоти сақланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Фойдаланувчи маълумоти сақлашда хатолик', 2, 'bottom');
      });
  };

  const addUser = () => {
    showBlured({
      title: 'Фойдаланувчи қўшиш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={formData}
          cancel={hideModal}
          sendData={sendData}
          selectOptions={sections}
          id=''
          initialVal={initialValuesAdd}
        />
      ),
    });
  };
  // Update

  const updateData = (id, data) => {
    hideModal();
    setLoading(true);
    userService
      .update(id, data)
      .then(() => {
        setBool(!bool);
        success('Фойдаланувчи маълумоти янгиланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Фойдаланувчи маълумоти янгилашда хатолик', 2, 'bottom');
      });
  };

  const handleEdit = (data) => {
    setLoading(true);
    userService
      .getOne(data._id)
      .then((resp) => {
        setLoading(false);

        showBlured({
          title: 'Фойдаланувчини таҳрирлаш',
          maxWidth: '650px',
          height: '600px',
          withHeader: false,
          body: () => (
            <FormCreator
              formData={formData}
              cancel={hideModal}
              sendData={updateData}
              selectOptions={sections}
              id={resp._id}
              initialVal={changeUpdateData(resp)}
            />
          ),
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        error('Фойдаланувчи маълумоти олишда хатолик', 2, 'bottom');
      });
  };

  // Delete

  const deleteUser = (id) => {
    hideModal();
    setLoading(true);
    userService
      .delete(id)
      .then(() => {
        setBool(!bool);
        success('Фойдаланувчи маълумоти ўчирилди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Фойдаланувчи маълумоти ўчиришда хатолик', 2, 'bottom');
      });
  };

  const handleDelete = (data) => {
    showBlured({
      title: "O'chirish",
      maxWidth: '400px',
      height: '300px',
      withHeader: false,

      body: () => <Confirm agree={() => deleteUser(data)} cancel={hideModal} />,
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (
        (search !== undefined && search?.length === 0) ||
        search?.length > 3
      ) {
        setPage(1);
        fetchUserData();
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (
        (searchText !== undefined && searchText?.length === 0) ||
        searchText?.length > 3
      ) {
        fetchUserData();
        setPage(1);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchText]);

  const columns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      width: '10%',
      align: 'center',
    },
    {
      title: 'Фамилия',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Исм',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Туман/Шахар',
      dataIndex: 'region',
      key: 'region',
    },
    {
      title: 'Гуруҳ',
      dataIndex: 'group',
      key: 'group',
    },
    {
      title: 'МФЙ',
      // dataIndex: "object",
      key: 'object',
      render: (_, row) => row && row.object?.title,
    },
    {
      title: 'Инфо',
      dataIndex: 'info',
      key: 'info',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: 'Телефон рақами',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
    },
    {
      width: '15%',
      align: 'center',
      title: 'Амал',
      dataIndex: '',
      key: 'x',
      render: (props) => (
        <ActionButton
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          props={props}
        />
      ),
    },
  ];
  if (loading) return <FullScreen />;

  const combineData = (users) => {
    const newData = users.map((item) => {
      const region =
        sections.region &&
        sections.region.find((itm) => itm._id === item.region);
      const group =
        sections.group &&
        sections.group.find((itm) => itm._id === (item.group && item.group[0]));
      return {
        ...item,
        region: region?.title,
        group: item.group && item.group.length === 1 && group?.title,
        info:
          item?.info?.appVersion != ''
            ? item?.info?.version + ', ' + 'App:' + item?.info?.appVersion
            : '',
      };
    });
    return newData
      .sort((a, b) => (a.region < b.region ? -1 : 1))
      .map((item, ind) =>
        page == 1
          ? { ...item, key: ind + 1 }
          : { ...item, key: (page - 1) * size + ind + 1 }
      );
  };

  const onChange = (page) => {
    setPage(page);
  };

  const onShowSizeChange = (current, pageSize) => {
    setPage(1);
    setSize(pageSize);
  };

  const handleSelect = (value, name) => {
    setPage(1);
    setFilterItems((prevVal) => ({
      ...prevVal,
      [name]: value,
    }));
  };

  return (
    <Container>
      <AddContainer>
        <AddButton text='Фойдаланувчи' addData={addUser} />
      </AddContainer>
      <Typograpy>Фойдаланувчилар </Typograpy>

      <Row>
        <Col span={24}>
          <Space>
            Шаҳар (Туман)
            <Select
              value={filterItems?.region != '' ? filterItems?.region : null}
              style={{ maxWidth: 300, minWidth: 200 }}
              allowClear
              onChange={(value) => handleSelect(value, 'region')}
            >
              {sections.region?.map((item, ind) => (
                <Option key={ind + 1} value={item._id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            Гуруҳ
            <Select
              value={filterItems?.group != '' ? filterItems?.group : null}
              allowClear
              onChange={(value) => handleSelect(value, 'group')}
            >
              {sections.group?.map((item, ind) => (
                <Option key={ind + 1} value={item._id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            Роле
            <Select
              value={filterItems?.role != '' ? filterItems?.role : null}
              allowClear
              onChange={(value) => handleSelect(value, 'role')}
            >
              {sections.role?.map((item, ind) => (
                <Option key={ind + 1} value={item._id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            МФЙ
            <Select
              value={filterItems?.object != '' ? filterItems?.object : null}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label.toLowerCase() ?? '').includes(
                  input.toLowerCase()
                )
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? '')
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? '').toLowerCase())
              }
              onChange={(value) => handleSelect(value, 'object')}
              options={sections?.objects?.map((item) => ({
                label: item?.title,
                value: item?._id,
              }))}
            >
              {/* {sections.objects?.map((item, ind) => (
                <Option key={ind + 1} value={item._id}>
                  {item.title}
                </Option>
              ))} */}
            </Select>
            <Input
              placeholder='Телефон бўйича қидирув...'
              allowClear
              prefix={<FiSearch color='#CCCCCC' size={12} />}
              className='search'
              style={{
                background: '#FFFFFF',
                border: '1px solid rgba(0, 0, 0, 0.07)',
                borderRadius: '10px',
                height: '42px',
                fontSize: '14px',
                minWidth: '160px',
              }}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <Input
              placeholder='Исм ёки фамилия орқали...'
              allowClear
              prefix={<FiSearch color='#CCCCCC' size={12} />}
              className='search'
              style={{
                background: '#FFFFFF',
                border: '1px solid rgba(0, 0, 0, 0.07)',
                borderRadius: '10px',
                height: '42px',
                fontSize: '14px',
                minWidth: '160px',
              }}
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
            />
          </Space>
        </Col>
      </Row>

      <Table
        bordered
        columns={columns}
        dataSource={combineData(users)}
        pagination={false}
      />
      {total / size > 1 && (
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
          <Pagination
            total={total}
            current={page}
            defaultPageSize={size}
            showSizeChanger
            onChange={onChange}
            onShowSizeChange={onShowSizeChange}
          />
        </div>
      )}
    </Container>
  );
};
